<template>
    <div>

        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>

        <v-container>
            <v-form ref="form">
                <v-row>
                    <h2 class="pb-5 pl-7">{{ this.parentObject.pageTitle }}<span class="page_title_value pl-2">{{ this.parentObject.pageTitleValue }}</span></h2>
                </v-row>

                <!-- <v-row>
                    <div class="pt-2 pl-7 pb-5">
                        <v-row>
                        <v-col>
                        <v-btn 
                            color="warning" 
                            style="width: 70px;"
                            @click="backHandler" 
                            > 
                            Back
                        </v-btn>
                        </v-col>

                        </v-row>

                    </div>
                </v-row> -->
                
                <v-container
                    id="scroll-target"
                    class="custom-form overflow-y-auto px-5 ml-n1"
                >

                    <div>
                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.exercisecode')"
                                    ref="reviewcode"
                                    readonly
                                    v-model="formData.reviewcode"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>


                            <v-col cols="8" sm="8" class="pb-n5">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.exercisedesc')"
                                    ref="description"
                                    readonly
                                    v-model="formData.description"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.startdate')"
                                    ref="startdate"
                                    type="date"
                                    readonly
                                    v-model="formData.startdate"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>


                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.enddate')"
                                    ref="enddate"
                                    type="date"
                                    readonly
                                    v-model="formData.enddate"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="3" sm="3" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('pmreviewexercise.assessmenttype')"
                                    ref="assessmentcode"
                                    type="text"
                                    readonly
                                    v-model="formData.assessmentcode"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="2" class="pb-n5 mt-n6">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.type')"
                                    ref="type"
                                    type="text"
                                    readonly
                                    v-model="formData.type"
                                    dense
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="2" sm="2" class="mt-n6 mb-4 mr-6">
                                <v-text-field class="big-field"
                                    :label="$t('appraisalexerciserecords.initiated')"
                                    outlined
                                    readonly
                                    type="text"
                                    v-model="formData.initiated"
                                    background-color="#6DB961"
                                    style="min-width: 200px;"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2" sm="2" class="mt-n6 mb-4 mr-6">
                                <v-text-field class="big-field"
                                    :label="$t('appraisalexerciserecords.ongoing')"
                                    outlined
                                    readonly
                                    type="text"
                                    v-model="formData.ongoing"
                                    background-color="#6DB961"
                                    style="min-width: 200px;"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2" sm="2" class="mt-n6 mb-4">
                                <v-text-field class="big-field"
                                    :label="$t('appraisalexerciserecords.completed')"
                                    outlined
                                    readonly
                                    type="text"
                                    v-model="formData.completed"
                                    style="min-width: 200px;"
                                    background-color="#6DB961"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>

                <v-container>
                    <div>
                        <v-row>
                            <app-table
                                v-bind:parentObject = "{
                                    tabHeader: this.tabHeader,
                                    detailItem: this.staffList,
                                    formData: this.formData,
                                    pageTitle: this.pageTitle,
                                    pageTitleValue: this.pageTitleValue,
                                    reviewStaffReviewerList: this.reviewStaffReviewerList
                                }"
                                @staffAdded="incrementCounts"
                                @staffDeleted="decrementCounts"
                            />
                        </v-row>
                    </div>
                </v-container>

                <v-row>
                    <div class="pt-5 pl-7">
                        <v-row>
                        <v-col>
                        <v-btn 
                            color="warning" 
                            style="width: 100px; margin-bottom: 20px;"
                            @click="closeHandler" 
                            > 
                              {{$t('button.close')}}
                        </v-btn>
                        </v-col>

                        </v-row>
                    </div>
                </v-row>

            </v-form>
        </v-container>
    </div>
</template>

<script>
import CRUDTable from './CRUDTableStaff';

export default {
    props: {
        parentObject: Object
    },

    components: {
       'app-table': CRUDTable,
    },


    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || this.$t('periodicincentivesetup.invalidemail');
                }
            },

            formData: this.parentObject.data,
            staffList: this.parentObject.staffList,
            pageTitle: this.parentObject.pageTitle,
            pageTitleValue: this.parentObject.pageTitleValue,
            
            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '100px', sortable: false},
                { text: this.$t('columns.staffid'), value: 'staffcode', width: '200px', sortable: true},
                { text: this.$t('columns.name'), value: 'staffname', width: '200px', sortable: true},
                // { text: 'Reviewer', value: 'reviewercode', width: '200px', sortable: true},
                // { text: 'Reviewer Name', value: 'reviewername', width: '200px', sortable: true},
                { text: this.$t('columns.startdate'), value: 'startdate', width: '200px', sortable: true},
                { text: this.$t('columns.enddate'), value: 'enddate', width: '200px', sortable: true},
                { text: this.$t('columns.status'), value: 'statuscode', width: '200px', sortable: true},
                { text: this.$t('Setupratingscaleset.score'), value: 'score', width: '200px', sortable: true},
                { text: this.$t('Setuprankingset.rank'), value: 'rank', width: '200px', sortable: true},
                { text: this.$t('columns.company'), value: 'compnycode', width: '200px', sortable: true},
                { text: this.$t('columns.branch'), value: 'brchcode', width: '200px', sortable: true},
                { text: this.$t('columns.department'), value: 'deptcode', width: '200px', sortable: true},
                { text: this.$t('columns.section'), value: 'sectiocode', width: '200px', sortable: true},
                { text: this.$t('columns.unit'), value: 'unitcode', width: '200px', sortable: true},
                { text: this.$t('columns.grade'), value: 'grdcode', width: '200px', sortable: true},
                { text: this.$t('columns.position'), value: 'poscode', width: '200px', sortable: true},
            ],

            errMsg: "",
            isErr: false,

            reviewStaffReviewerList: [],
        }
    },

    methods: {
        incrementCounts(statusId) {
            if (statusId === 4) {
                this.formData.initiated += 1; // Increment for initiated status
            } else if (statusId === 5) {
                this.formData.ongoing += 1; // Increment for ongoing status
            } else if (statusId === 6) {
                this.formData.completed += 1; // Increment for completed status
            }
        },

        decrementCounts(statusId) {
            // Decrease the count based on the statusId
            if (statusId === 4) {
                this.formData.initiated = Math.max(0, this.formData.initiated - 1);
            } else if (statusId === 5) {
                this.formData.ongoing = Math.max(0, this.formData.ongoing - 1);
            } else if (statusId === 6) {
                this.formData.completed = Math.max(0, this.formData.completed - 1);
            }
        }, 

        closeHandler(){
            this.$router.push({name: 'reviewexerciselist'});
        },

        loadReviewStaffReviewer(){
            const vm = this;
            this.$store.dispatch('get', {url: "/reviewexercisestaff/reviewexercise/" + vm.formData.pmreviewexerciseid})
            .then((res) => {
            if (res.status == 200) {
                vm.reviewStaffReviewerList = res.data.rec;
            }else {
                vm.isErr = !vm.isErr;
            }})
            .catch((err) => {
                console.log(err);
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            });
        },
    },

    mounted() {
        this.loadReviewStaffReviewer();
    }
}
</script>

<style scoped>
::v-deep .big-field .v-text-field__slot input {
    color: white !important;
    font-size:18px;
    font-weight:bold;
}

::v-deep .big-field .v-label {
    font-size:20px;
    font-weight:bold;
    color: white; 
    text-shadow: 1px 1px 2px black, -0.5px -0.5px 0 #000, 0.5px -0.5px 0 #000, -0.5px 0.5px 0 #000, 0.5px 0.5px 0 #000; 

}
</style>
